var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 1.16663C10.494 1.16663 1.16663 10.494 1.16663 22C1.16663 33.5058 10.494 42.8333 22 42.8333C33.5058 42.8333 42.8333 33.5058 42.8333 22C42.8333 10.494 33.5058 1.16663 22 1.16663Z",
    stroke: "#434289",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89795 35.2202C5.89795 35.2202 10.5417 29.2916 22 29.2916C33.4584 29.2916 38.1023 35.2202 38.1023 35.2202",
    stroke: "#434289",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 22C25.4519 22 28.25 19.2019 28.25 15.75C28.25 12.2982 25.4519 9.5 22 9.5C18.5481 9.5 15.75 12.2982 15.75 15.75C15.75 19.2019 18.5481 22 22 22Z",
    stroke: "#434289",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/Profile-Icon.4fe14fd2e9013cda044e01cf13641580.svg";
export { ForwardRef as ReactComponent };